/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API38472Item {
  
  /** 模块id */
  moduleId?: string;
  
  /** 模块名称 */
  moduleName?: string;
  
  /** 菜单列表 ,ResourceMenuDto */
  menuResourceList?: API38472Item[];
  
  /** 其他资源列表 ,ResourceMenuDto */
  otherResourceList?: API38472Item[];
  
  /** 导航栏展示类型 */
  showType?: string;
  
};
    
  



export interface API38472Req {
  
  /** 云分类id */
  cloudCategoryId?: string;
    
};



export interface API38472Res {
  /** T  */
  list?: API38472Item[];
  /** 云分类id  */
  cloudCategoryId?: string;
  
};


// 38472 根据云分类id获取有权限的模块和菜单资源

export interface IUseGetAPI38472Return {
  /** 根据云分类id获取有权限的模块和菜单资源: 接口请求状态 */
  isAPI38472Loading: boolean;
  /** 根据云分类id获取有权限的模块和菜单资源: 接口请求返回数据 */
  dataAPI38472: API38472Res;
  /**  根据云分类id获取有权限的模块和菜单资源: 接口数据请求方法 */
  fetchAPI38472Data:  (inputs: API38472Req, config?: YWRequestConfig) => Promise<API38472Res>;
  /** 根据云分类id获取有权限的模块和菜单资源: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI38472 = ():IUseGetAPI38472Return => {
  let isMount = true;
  const [isAPI38472Loading, setIsAPI38472Loading] = useState(false);
  const [dataAPI38472, setDataAPI38472] = useState<API38472Res>({} as API38472Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/resource/list/cloud/modules`;

  const fetchAPI38472Data = async (inputs: API38472Req, config?: YWRequestConfig): Promise<API38472Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API38472Req>) || {}) as API38472Req;
    
  
    if ( isMount ) {
      setIsAPI38472Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API38472Res>(`${basePath}/ywwl-admin/desktop/resource/list/cloud/modules?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI38472(res || {} as API38472Res);
        setIsAPI38472Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI38472Loading(false);
      }
      return false as unknown as API38472Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI38472Loading,
    dataAPI38472,
    fetchAPI38472Data,
    requestUrl,
  }
}

